<template>
    <div>
        <a-card title="配置日志">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>

            <a-form layout="inline" @keyup.enter.native="handleSubmit" >
                 <a-form-item label="应用编码" >
                    <AppAutoComplete ref="appcodeAss"  @onAppCodeChange="handleSearchAppcodeChange"></AppAutoComplete>
                </a-form-item>
                <a-form-item label="操作类型">
                    <a-select v-model="searchP.actiontype"  placeholder="" style="width:100px;">
                        <a-select-option value="">
                        全部
                        </a-select-option>
                        <a-select-option value="create">
                        新增
                        </a-select-option>
                        <a-select-option value="update">
                        修改
                        </a-select-option>
                        <a-select-option value="delete">
                        删除
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="操作者">
                    <a-input
                        allow-clear
                        v-model="searchP.createusername"
                        placeholder="操作者"
                    ></a-input>
                </a-form-item>
                <a-form-item label="配置项">
                    <a-input
                        allow-clear
                        v-model="searchP.configitem"
                        placeholder="配置项"
                    ></a-input>
                </a-form-item>
                
                <a-form-item>
                    <a-button
                        type="primary"
                        @click="handleSubmit"
                    >筛选</a-button>
                </a-form-item>
                <a-form-item>
                <a-button
                        type="default"
                        @click="handleSearchReset"
                    >重置</a-button>
                </a-form-item>
            </a-form>
        
        <!-- 系统列表 -->
        <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="id" style="margin-top:20px;" >
            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <span>
                        <router-link
                                :to="{
                                path:'detaillog',
                                query: {
                                    id: record.id
                                }
                            }"
                            >详情</router-link>
                    </span>
                </div>
            </template>

            <span slot="actiontypet" :class="oprationClass[text]" slot-scope="text">{{ oprationname[text] }}</span>
        </a-table>

        <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />
        </a-card>
    </div>
</template>

<script>
import AppAutoComplete from '@/components/AppAutoComplete'
const oprationname = {
    'create':'新增',
    'update':'更新',
    'delete':'删除'
}
const oprationClass = {
    'create':'color_green',
    'update':'color_blue',
    'delete':'color_red'
}

const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = searchP;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: 'appcode',
        dataIndex: 'appcode',
        align: 'center',
        width:100
    },
    {
        title: '操作人姓名',
        dataIndex: 'createusername',
        align: 'center',
        width:100
    },
    {
        title: 'usercode',
        dataIndex: 'createuser',
        align: 'center',
        width:100
    },
    {
        title: '操作类型',
        dataIndex: 'actiontype',
        align: 'center',
        scopedSlots: { customRender: 'actiontypet' },
        width:100
    },
    
    {
        title: '配置项',
        dataIndex: 'configitem',
        align: 'center',
        width:100
    },
    {
        title: '配置项(源)',
        dataIndex: 'configvaluesource',
        ellipsis:true,
        align: 'left',
        width:200

    },
    {
        title: '配置项参数',
        dataIndex: 'configvalue',
        align: 'left',
        ellipsis:true,
        width:200

    },
    {
        title: '备注',
        dataIndex: 'remark',
        align: 'center',
        ellipsis:true,
        width:200

    },
    {
        title: '修改时间',
        dataIndex: 'createtime',
        align: 'center',
        width:100

    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
        width:100

    },
];


let searchP={
    appcode:'',
    actiontype:'',
    createusername:'',
    configitem:'',
    total:0,
    pageSize:10,
    page:undefined,
};

const data = [];
export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            oprationname,
            columns,
            searchP:searchP,
            tLoading:true,
            oprationClass
            
        };
    },
    methods: {
        handleSearchAppcodeChange(value){
            this.searchP.appcode = value;
        },
        handleSearchReset(){
            this.searchP.page = 1;
            this.searchP.appcode = '';
            this.searchP.actiontype = '';
            this.searchP.createusername = '';
            this.updateRoute()
        },
        handleSubmit(){
            this.searchP.page = 1;
            this.updateRoute()
        },
        getFileList(){
            let c_params = {
                ...this.searchP
            }
            this.tLoading = true,
            this.$store.dispatch({
                type: "configcenter/queryConfigLogPage",
                params:c_params
            }).then((res)=>{
                this.tLoading = false;
                let result = res.data.data;
                this.data = result.list;
                this.searchP.total = result.totalRecords;
                this.searchP.pageSize = result.pageSize;
                this.searchP.page = result.page;
            })
        },
        // 分页事件
        handlePageChange(c){
            this.searchP.page = c;
            this.updateRoute()
        },
        updateRoute(){
            this.$router.push({
                query: {
                    appcode:this.searchP.appcode,
                    actiontype:this.searchP.actiontype,
                    createusername:this.searchP.createusername,
                    page:this.searchP.page
                }
            });
        },
        handleNewFile(){
            this.$router.push({
                path:'edit',
                query: {
                    id:''
                }
            });            
        },
        onFileDelete(key){
            this.$store.dispatch({
                type: "configcenter/deleteFile",
                params: {...key}
            }).then((res) => {
                if(res.status == '200'){
                    this.getFileList();
                }
            });
        },
       
    },
    computed: {},
    components: {
        AppAutoComplete
    },
    watch: {
        '$route' () {
            this.$router.go(0);
        }
    },
    mounted() {
        let query = this.$route.query;
        this.searchP.appcode = query.appcode ? query.appcode : '';
        this.searchP.actiontype = query.actiontype ? query.actiontype : '';
        this.searchP.createusername = query.createusername ? query.createusername : '';
        this.searchP.configitem = query.configitem ? query.configitem : '';

        this.searchP.page = query.page ? +query.page : 1;
        this.$refs.appcodeAss.setInputVal(this.searchP.appcode);
        this.getFileList();
    },
    created() {
 
    }
};
</script>

<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}

.color_green{
    color: green;
}

.color_blue{
    color: blue;
}

.color_red{
    color: red;
}
</style>